import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";
import {
  currentUserReducer,
  allRequestsReducer,
  ownRequestsReducer,
  participantsRequestsReducer,
  workflowConfigurationReducer,
  historyRequests,
} from "./slices";
import AppRootSaga from "./saga/AppRootSaga";
import createSagaMiddleware from "redux-saga";

const reducer = combineReducers({
  currentUser: currentUserReducer,
  allRequests: allRequestsReducer,
  ownRequests: ownRequestsReducer,
  historyRequests: historyRequests,
  participantsRequests: participantsRequestsReducer,
  workflowConfiguration: workflowConfigurationReducer,
});

/**
 * @param {{ preloadedState?: object, rootSaga?: Function }} options
 */
export const createAppStore = ({
  preloadedState,
  rootSaga = AppRootSaga,
} = {}) => {
  const sagaMiddleware = createSagaMiddleware();
  const middleware = [...getDefaultMiddleware({ thunk: false }), sagaMiddleware];
  const store = configureStore({
    reducer,
    preloadedState,
    middleware,
    devTools: process.env.NODE_ENV !== "production",
  });

  sagaMiddleware.run(rootSaga);
  return store;
};

const AppStore = createAppStore();

export default AppStore;
